import { capitalizeString } from '../../capitalizeString';

export const formatMonthAndYear = (date: Date): string => {
  try {
    return capitalizeString(date.toLocaleDateString('sv-SE', { year: 'numeric', month: 'long' }));
  } catch {
    return '';
  }
};
